import axios from 'axios';

const fetchListingsFromLambda = async () => {
  try {
    // Replace the URL with your API Gateway URL that triggers the Lambda function
    const apiGatewayURL = 'https://pptui2zamfxug7jrfrtnq5lzsa0bcsah.lambda-url.us-west-1.on.aws/';

    const response = await axios.get(apiGatewayURL);

    if (response.status === 200) {
      const listings = response.data;
      return listings;
    } else {
      console.error('Failed to fetch listings:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error fetching listings:', error);
    return null;
  }
};

export default fetchListingsFromLambda;